/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_ProductInputs */

const en_share_product = /** @type {(inputs: Share_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Product`)
};

const es_share_product = /** @type {(inputs: Share_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir Producto`)
};

const fr_share_product = /** @type {(inputs: Share_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager le produit`)
};

const de_share_product = /** @type {(inputs: Share_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt teilen`)
};

const id_share_product = /** @type {(inputs: Share_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan Produk`)
};

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const ja_share_product = en_share_product;

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const zh_share_product = en_share_product;

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const ar_share_product = en_share_product;

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const it_share_product = en_share_product;

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const ru_share_product = en_share_product;

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const pt_share_product = en_share_product;

/** @type {(inputs: Share_ProductInputs) => LocalizedString} */
const ko_share_product = en_share_product;

/**
* | output |
* | --- |
* | "Share Product" |
*
* @param {Share_ProductInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share_product = /** @type {((inputs?: Share_ProductInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ProductInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_product(inputs)
	if (locale === "es") return es_share_product(inputs)
	if (locale === "fr") return fr_share_product(inputs)
	if (locale === "de") return de_share_product(inputs)
	if (locale === "ja") return ja_share_product(inputs)
	if (locale === "zh") return zh_share_product(inputs)
	if (locale === "ar") return ar_share_product(inputs)
	if (locale === "id") return id_share_product(inputs)
	if (locale === "it") return it_share_product(inputs)
	if (locale === "ru") return ru_share_product(inputs)
	if (locale === "pt") return pt_share_product(inputs)
	return ko_share_product(inputs)
});